import { Chip } from "../../../../components/common/chip";
import { ChangeRequestDtoStatusEnum } from "../../../../api";
import type { ChangeRequestStatus } from "../../data/change-request-status";

export interface ChangeRequestStatusBadgeProps {
  status: ChangeRequestStatus;
  className?: string;
}

export function ChangeRequestStatusBadge({ status }: ChangeRequestStatusBadgeProps) {
  switch (status) {
    case ChangeRequestDtoStatusEnum.Approved:
      return <Chip variant="approved">Approved</Chip>;
    case ChangeRequestDtoStatusEnum.Rejected:
      return <Chip variant="rejected">Rejected</Chip>;
    case ChangeRequestDtoStatusEnum.Cancelled:
      return <Chip variant="expired">Cancelled</Chip>;
    case ChangeRequestDtoStatusEnum.Draft:
      return <Chip variant="expired">Draft</Chip>;
    case ChangeRequestDtoStatusEnum.ChangesRequested:
      return <Chip variant="inReview">Changes requested</Chip>;
    default:
      return <Chip variant="inReview">Pending</Chip>;
  }
}
